import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      width: '100%',
      borderRadius: '5px',
      padding: '1.6rem',
      border: '1px solid #ABABAB',

      '& .MuiTypography-h4': {
        padding: '0.5rem 0 2rem 0',
      },
      '& .MuiFormControl-root': {
        width: '100%',
        margin: 0,

        '& input': {
          cursor: 'pointer',
        },
      },
      '& .MuiSvgIcon-root': {
        color: '#ABABAB',
      },
    },
    wrapperCards: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, 252px)',
      gap: '1rem',
    },
    card: {
      borderRadius: '5px',
      padding: '1.6rem',
      border: '1px solid #ABABAB',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.6rem',
    },
    cardButton: {
      width: '100%',
      height: '3rem',
      margin: 0,
      textTransform: 'uppercase',
    },
  }),
)
